// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Ach } from './ach';
import { Invoice } from './invoice';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AchTransaction extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  achId!: number;
  amount!: number;
  bankConfirmationNumber?: string;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  depositAcknowledged?: Date;
  depositAcknowledgedBy?: string;
  invoiceId!: number;
  notes?: string;
  transferInitiated?: Date;
  transferInitiatedBy?: string;
  ach!: Ach;
  invoice!: Invoice;
}

